import HoaDonPage from "../hoa-don/HoaDonPage";

const HoaDonMayTinhTienPage = () => <HoaDonPage variant="mtt" />;

export default HoaDonMayTinhTienPage;
